import React from 'react';
import {Progress} from "antd";
import _ from "lodash";

export default ({title, num, max, steps, noNums, checkmarkOnly, ...props}) => {
  if (steps)
    props = { steps: max }

  if (_.isArray(num))
    num = num.length;

  if (_.isArray(max))
    max = max.length;

  let format;
  let atMax = num === max;

  if (checkmarkOnly)
    noNums = !atMax;

  if (noNums || num === max)
    format = "";
  else
    format = () => `${num}/${max}`

  return <div>
    {title && <div style={{fontSize: "12px"}}>{title}</div>}
    <Progress showInfo={!noNums} percent={num*100/max} format={format} {...props} />
  </div>
}

